// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./part11-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Part11Indicator__icon___a8Vc{background:no-repeat url(${___CSS_LOADER_URL_REPLACEMENT_0___});min-height:1.2em;min-width:1.2rem}
`, "",{"version":3,"sources":["webpack://./src/js/apps/common/components/Part11Indicator/Part11Indicator.scss"],"names":[],"mappings":"AAAA,8BACI,4DAA8C,CAC9C,gBAAiB,CACjB,gBAAiB","sourcesContent":[".icon {\n    background: no-repeat url('./part11-icon.svg');\n    min-height: 1.2em;\n    min-width: 1.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `Part11Indicator__icon___a8Vc`
};
export default ___CSS_LOADER_EXPORT___;
